import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import type { MouseEvent } from 'react'

/** Open https / App Store links in Safari on iOS (not trapped in the WebView). */
export async function openExternalUrl(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url })
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function openExternalLink(event: MouseEvent<HTMLAnchorElement>, url: string): void {
  if (url.startsWith('mailto:')) return
  event.preventDefault()
  void openExternalUrl(url)
}
